import { Spreadsheet } from '@/components/spreadsheet/spreadsheet';
import * as _ from 'lodash';
import * as moment from 'moment';

export class DapSpreadsheetAprovationFlowRetailConsolidate extends Spreadsheet {
  mount(dataSource: any[]) {
    // console.log('dataSource');
    // console.log(dataSource);
    // console.log('-----------------------');

    this.name = 'Toyota_Dap_Pleito_Fluxo_Aprovação_Consolidado_v';

    const totalMonths = dataSource[0].forecast_RapFamilyResultsPerMonth.length;
    const totalConsolidado = dataSource[0].consolidate.length;

    const totalMonthHierarchy = [
      ..._(dataSource[0].forecast_RapFamilyResultsPerMonth)
        .groupBy((d: any) => d.approvalHierarchy)
        .map((d: any) => [...d])
        .value()
    ][0].length;

    const initialValue = 13;

    const forescast = _(dataSource[0].forecast_RapFamilyResultsPerMonth)
      .groupBy((d: any) => d.approvalHierarchy)
      .map((d: any) => [...d])
      .value();

    const forecastDescription = _(dataSource[0].forecast_Description)
      .groupBy((d: any) => d.approvalHierarchy)
      .map((d: any) => [...d])
      .value();

    const monthAnnualPlan = dataSource[0].monthlyAnnualPlan;
    const monthlyAnnualPlanNormalization = dataSource[0].monthlyAnnualPlanNormalization;

    // console.log('-------------');
    // console.log(monthAnnualPlan);
    // console.log('-------------');

    const idsHierarchy = _(forescast)
      .map((d: any, i: number) => d[0].approvalHierarchy)
      .value();

    const idsHierarchyDescription = _(forescast)
      .map((d: any, i: number) => d[0].approvalHierarchy.toString() + d[0].approvalHierarchy.toString())
      .value();

    const title = 'DEALER ANNUAL PLAN - FLUXO APROVAÇÃO';

    const sections: Array<any> = [
      { key: 'main', text: title, index: 0 },
      { key: 'consolidate', text: '', index: initialValue },
      { key: 'forecast_year_now', text: '', index: initialValue + 1 },
      ..._(forescast)
        .map((d: any, i: number) => ({
          key: d[0].approvalHierarchy.toString(),
          text: '',
          index: initialValue + totalConsolidado + 2 + (i == 0 ? 0 : i * totalMonthHierarchy)
        }))
        .value(),
      {
        key: 'monthlyAnnualPlan',
        text: 'MONTHLY ANNUAL PLAN',
        index: initialValue + totalConsolidado + 1 + forescast.length * totalMonthHierarchy
      },
      {
        key: 'monthlyAnnualPlanNormalization',
        text: 'MONTHLY ANNUAL PLAN - TDB SHARE NORMALIZATION',
        index: initialValue + totalConsolidado + 1 + forescast.length * totalMonthHierarchy + monthAnnualPlan.length
      },
      {
        key: 'forecast_description',
        text: 'OBSERVAÇÕES FLUXO APROVAÇÂO',
        index:
          initialValue +
          totalConsolidado +
          1 +
          forescast.length * totalMonthHierarchy +
          monthAnnualPlan.length +
          monthlyAnnualPlanNormalization.length
      }
    ];

    const sectionColumnsDescription: any = [
      {
        key: 'main',
        source: [{ key: 'keyValue', text: 'DATA: ' + moment(new Date()).format('DD/MM/YYYY hh:mm') }]
      },
      {
        key: 'consolidate',
        source: [{ key: 'consolidate', text: 'RESULTADO' }]
      },
      {
        key: 'forecast_year_now',
        source: [{ key: 'forecast_year_now', text: 'FORECAST' }]
      },
      ..._(forescast)
        .map((d: any, i: number) => ({
          key: d[0].approvalHierarchy.toString(),
          source: _(d)
            .map((d: any) => ({
              key: 'approvalHierarchy',
              text: d.approvalHierarchyName
            }))
            .uniqBy((d: any) => d.text)
            .value(),
          index: initialValue + totalConsolidado + (i == 0 ? 0 : i * totalMonthHierarchy)
        }))
        .value(),
      {
        key: 'monthlyAnnualPlan',
        source: [
          {
            key: 'monthlyAnnualPlan',
            text: monthAnnualPlan[0].year,
            index: initialValue + totalConsolidado + 1 + forescast.length * totalMonthHierarchy
          }
        ]
      },
      {
        key: 'monthlyAnnualPlanNormalization',
        source: [
          {
            key: 'monthlyAnnualPlanNormalization',
            text: monthlyAnnualPlanNormalization[0].year,
            index: initialValue + totalConsolidado + 1 + forescast.length * totalMonthHierarchy + monthAnnualPlan.length
          }
        ]
      },
      ..._(forecastDescription)
        .map((d: any, i: number) => ({
          key: d[0].approvalHierarchy.toString() + d[0].approvalHierarchy.toString(),
          source: _(d)
            .map((d: any) => ({
              key: 'forecast_Description',
              text: d.approvalHierarchyName
            }))
            .uniqBy((d: any) => d.text)
            .value(),
          index:
            initialValue +
            totalConsolidado +
            1 +
            forescast.length * totalMonthHierarchy +
            monthAnnualPlan.length +
            monthlyAnnualPlanNormalization.length +
            (i == 0 ? 0 : i)
        }))
        .value()
    ];

    const sectionColumns: any = [
      {
        key: 'main',
        source: [
          { key: 'dealerNumber', text: 'DN' },
          { key: 'dealerName', text: 'NOME' },
          { key: 'groupName', text: 'GROUP' },
          { key: 'idStoreMatrixBefore', text: 'DN MATRIX BEFORE' },
          { key: 'markedAreaName', text: 'ÁREA DEMARCADA' },
          { key: 'region', text: 'REGIÃO' },
          { key: 'aov', text: 'AOV' },
          { key: 'regionale', text: 'REGIONAL' },
          { key: 'familyName', text: 'FAMÍLIA' },

          { key: 'tdbCompleted', text: 'TDB FINALIZADO' },
          { key: 'regioesCompleted', text: 'CONSULTORES FINALIZADO' },
          { key: 'aovCompleted', text: 'AOV FINALIZADO' },
          { key: 'comiteCompleted', text: 'TDB FINAL FINALIZADO' }
        ]
      },
      {
        key: 'consolidate',
        source: [
          ..._(dataSource[0].consolidate)
            .map((d: any) => ({
              key: 'value',
              text: d.description,
              format: '#,0'
            }))
            .value()
        ]
      },
      {
        key: 'forecast_year_now',
        source: {
          ..._.map(dataSource[0].forecast_year_now, (d: any) => ({
            key: 'value',
            text: 'OAP ' + d.year.toString().slice(2, 4) + '\'',
            format: '#,0'
          }))
        }
      },
      ..._(forescast)
        .map((d: any, i: number) => ({
          key: d[0].approvalHierarchy.toString(),
          source: _(d)
            .map((d: any) => ({
              key: 'value',
              text: 'OAP ' + d.year.toString().slice(2, 4) + '\'',
              format: '#,0'
            }))
            .value()
        }))
        .value(),
      {
        key: 'monthlyAnnualPlan',
        source: _(monthAnnualPlan)
          .map((d: any, i: number) => ({
            key: 'value',
            format: '#,0',
            text: d.monthName
              .toUpperCase()
              .toString()
              .slice(0, 3)
          }))
          .value()
      },
      {
        key: 'monthlyAnnualPlanNormalization',
        source: _(monthlyAnnualPlanNormalization)
          .map((d: any, i: number) => ({
            key: 'indexValue',
            format: '#0.00%',
            text: d.monthName
              .toUpperCase()
              .toString()
              .slice(0, 3)
          }))
          .value()
      },
      ..._(forecastDescription)
        .map((m: any, i: number) => ({
          key: m[0].approvalHierarchy.toString() + m[0].approvalHierarchy.toString(),
          source: _(m)
            .map((d: any) => ({
              key: 'description',
              text: m[0].approvalHierarchyName.toString()
            }))
            .value()
        }))
        .value()
    ];

    const baseStyle: any = {
      color: '#212121',
      textAlign: 'left',
      fontSize: 9,
      verticalAlign: 'center',
      fontFamily: 'Calibri',
      monthlyAnnualPlan: '#212121',
      monthlyAnnualPlanNormalization: '#212121',
      forecast_description: '#212121'
    };

    const baseHeaderStyle: any = {
      color: '#212121',
      fontSize: 9,
      bold: true,
      textAlign: 'center',
      verticalAlign: 'center',
      fontFamily: 'Calibri',
      monthlyAnnualPlan: '#212121',
      monthlyAnnualPlanNormalization: '#212121',
      forecast_description: '#212121'
    };

    const baseColorStyle: any = {
      main: '#bdbdbd',
      consolidate: '#90a4ae',
      forecast_year_now: '#81c784',
      monthlyAnnualPlan: '#bdbdbd',
      monthlyAnnualPlanNormalization: '#e57373',
      forecast_description: '#ffb74d',

      '0': '#e57373',
      '1': '#ffb74d',
      '2': '#e57373',
      '3': '#ffb74d',
      '4': '#e57373',
      '5': '#ffb74d',
      '6': '#e57373',
      '7': '#ffb74d',
      '8': '#e57373',
      '9': '#ffb74d',
      '10': '#e57373',
      '00': '#ffb74d',
      '11': '#e57373',
      '22': '#ffb74d',
      '33': '#e57373',
      '44': '#ffb74d',
      '55': '#e57373',
      '66': '#ffb74d',
      '77': '#e57373',
      '88': '#ffb74d',
      '99': '#e57373'
    };

    const baseBorderColorStyle: any = {
      main: '#e0e0e0',
      consolidate: '#cfd8dc',
      forecast_year_now: '#c8e6c9',
      monthlyAnnualPlan: '#e0e0e0',
      monthlyAnnualPlanNormalization: '#e0e0e0',
      forecast_description: '#ffe0b2',

      '0': '#ffcdd2',
      '1': '#ffe0b2',
      '2': '#ffcdd2',
      '3': '#ffe0b2',
      '4': '#ffcdd2',
      '5': '#ffe0b2',
      '6': '#ffcdd2',
      '7': '#ffe0b2',
      '8': '#ffcdd2',
      '9': '#ffe0b2',
      '10': '#ffcdd2',
      '00': '#ffe0b2',
      '11': '#ffcdd2',
      '22': '#ffe0b2',
      '33': '#ffcdd2',
      '44': '#ffe0b2',
      '55': '#ffcdd2',
      '66': '#ffe0b2',
      '77': '#ffcdd2',
      '88': '#ffe0b2',
      '99': '#ffcdd2'
    };

    const baseBackgroundColorStyle: any = {
      main: '#fafafa',
      consolidate: '#f9fafb',
      forecast_year_now: '#f4f9f5',
      monthlyAnnualPlan: '#fafafa',
      monthlyAnnualPlanNormalization: '#fff5f6',
      forecast_description: '#fffbf5',
      '0': '#fff5f6',
      '1': '#fffbf5',
      '2': '#fff5f6',
      '3': '#fffbf5',
      '4': '#fff5f6',
      '5': '#fffbf5',
      '6': '#fff5f6',
      '7': '#fffbf5',
      '8': '#fff5f6',
      '9': '#fffbf5',
      '10': '#fff5f6',
      '00': '#fffbf5',
      '11': '#fff5f6',
      '22': '#fffbf5',
      '33': '#fff5f6',
      '44': '#fffbf5',
      '55': '#fff5f6',
      '66': '#fffbf5',
      '77': '#fff5f6',
      '88': '#fffbf5',
      '99': '#fff5f6'
    };

    const headerStyle = _.reduce(
      baseColorStyle,
      (acc: any, val: string, key: string) => {
        acc[key] = _.assign({}, baseHeaderStyle, { background: baseColorStyle[key] });
        return acc;
      },
      {}
    );

    const getCellStyle = (key: any) => {
      return _.assign({}, baseStyle, {
        textAlign: 'center',
        background: baseBackgroundColorStyle[key],
        borderLeft: { color: baseBorderColorStyle[key], size: 1 },
        borderRight: { color: baseBorderColorStyle[key], size: 1 },
        borderTop: { color: baseBorderColorStyle[key], size: 1 },
        borderBottom: { color: baseBorderColorStyle[key], size: 1 }
      });
    };

    this.workbookOptions = {
      sheets: _.map(
        [dataSource],
        (data: any, name: string) =>
          ({
            name: 'Estrategia_LocalFluxo_Aprovação',
            frozenColumns: 2,
            frozenRows: 3,
            filter: {
              ref: `A3:${
                this.columnIndex[
                  initialValue +
                    totalMonths +
                    monthAnnualPlan.length +
                    monthlyAnnualPlanNormalization.length +
                    totalConsolidado +
                    forecastDescription.length +
                    1 -
                    1
                ]
              }${data.length + 3}`,
              columns: []
            },
            rows: [
              {
                height: 30,
                cells: [
                  ..._.map(sections, (section: any) =>
                    _.assign({}, headerStyle[section.key], {
                      value: section.text,
                      index: section.index,
                      borderLeft: { color: baseBorderColorStyle[section.key], size: 1 },
                      borderRight: { color: baseBorderColorStyle[section.key], size: 1 }
                    })
                  )
                ]
              },
              {
                height: 30,
                cells: [
                  ..._(sectionColumnsDescription)
                    .map((columns: any, key: any) =>
                      _.map(columns.source, (cell: any) =>
                        _.assign({}, getCellStyle(cell.color || columns.key), {
                          value: cell.text,
                          bold: true,
                          index: cell.index,
                          textAlign: cell.key === 'keyValue' ? 'left' : 'center',
                          borderLeft: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderRight: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderTop: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderBottom: { color: baseBorderColorStyle[columns.key], size: 1 }
                        })
                      )
                    )
                    .flatten()
                    .value()
                ]
              },
              {
                height: 30,
                cells: [
                  ..._(sectionColumns)
                    .map((columns: any, key: any) =>
                      _.map(columns.source, (cell: any) =>
                        _.assign({}, headerStyle[cell.color || columns.key], {
                          value: cell.text,
                          wrap: true,
                          borderLeft: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderRight: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderTop: { color: baseBorderColorStyle[columns.key], size: 1 },
                          borderBottom: { color: baseBorderColorStyle[columns.key], size: 1 }
                        })
                      )
                    )
                    .flatten()
                    .value()
                ]
              },
              ..._.map(data, d => {
                return {
                  cells: [
                    ..._(sectionColumns)
                      .map((columns: any, key: any) =>
                        _.map(columns.source, (cell: any, index: number) => {
                          if (columns.key === 'forecast_year_now' || columns.key === 'consolidate') {
                            if (
                              !d ||
                              !d[columns.key] ||
                              !d[columns.key][index] ||
                              (!d[columns.key][index][cell.key] && d[columns.key][index][cell.key] != 0)
                            ) {
                              return _.assign({}, getCellStyle(cell.color || columns.key), {
                                value: 0,
                                format: cell.format
                              });
                            }
                            return _.assign({}, getCellStyle(cell.color || columns.key), {
                              value: d[columns.key][index][cell.key],
                              format: cell.format
                            });
                          }

                          if (columns.key === 'monthlyAnnualPlan') {
                            if (
                              !d ||
                              !d[columns.key] ||
                              !d[columns.key][index] ||
                              (!d[columns.key][index][cell.key] && d[columns.key][index][cell.key] != 0)
                            ) {
                              return _.assign({}, getCellStyle(cell.color || columns.key), {
                                value: 0,
                                format: cell.format
                              });
                            }
                            return _.assign({}, getCellStyle(cell.color || columns.key), {
                              value: d[columns.key][index][cell.key],
                              format: cell.format
                            });
                          }

                          if (columns.key === 'monthlyAnnualPlanNormalization') {
                            if (
                              !d ||
                              !d[columns.key] ||
                              !d[columns.key][index] ||
                              (!d[columns.key][index][cell.key] && d[columns.key][index][cell.key] != 0)
                            ) {
                              return _.assign({}, getCellStyle(cell.color || columns.key), {
                                value: 0,
                                format: cell.format
                              });
                            }
                            return _.assign({}, getCellStyle(cell.color || columns.key), {
                              value: d[columns.key][index][cell.key],
                              format: cell.format
                            });
                          }

                          if (idsHierarchy.some(s => s == columns.key)) {
                            return _.assign({}, getCellStyle(cell.color || columns.key), {
                              value: d.forecast_RapFamilyResultsPerMonth.filter(function(f) {
                                return f.approvalHierarchy == columns.key;
                              })[index][cell.key],
                              format: cell.format
                            });
                          }

                          if (idsHierarchyDescription.some(s => s == columns.key)) {
                            return _.assign({}, getCellStyle(cell.color || columns.key), {
                              value: d.forecast_Description.filter(function(f) {
                                return f.approvalHierarchy == columns.key.substr(0, 1);
                              })[index][cell.key],
                              format: cell.format
                            });
                          }

                          return _.assign({}, getCellStyle(cell.color || columns.key), {
                            value: d[cell.key],
                            format: cell.format,
                            textAlign: cell.textAlign || 'center'
                          });
                        })
                      )
                      .flatten()
                      .value()
                  ]
                };
              })
            ],
            columns: [
              {
                index: 0,
                width: 100
              },
              {
                index: 1,
                width: 150
              },
              {
                index: 2,
                width: 150
              },
              {
                index: 3,
                width: 80
              },
              {
                index: 4,
                width: 150
              },
              {
                index: 5,
                width: 150
              },
              {
                index: 6,
                width: 100
              },
              {
                index: 7,
                width: 100
              },
              {
                index: 8,
                width: 100
              },
              {
                index: 9,
                width: 150
              },
              {
                index: 10,
                width: 100
              },
              {
                index: 11,
                width: 100
              },
              {
                index: 12,
                width: 100
              },
              ..._.map(
                _.range(
                  0,
                  initialValue +
                    totalConsolidado +
                    1 +
                    forescast.length * totalMonthHierarchy +
                    monthAnnualPlan.length +
                    monthlyAnnualPlanNormalization.length
                ),
                index => ({
                  index: index,
                  width: 80
                })
              ),
              {
                index: 55,
                width: 400
              },
              {
                index: 56,
                width: 400
              },
              {
                index: 57,
                width: 400
              },
              {
                index: 58,
                width: 400
              },
              {
                index: 59,
                width: 400
              }
            ],
            showGridLines: false,
            mergedCells: [
              `A1:${this.columnIndex[initialValue + totalConsolidado + totalMonths + 1 - 1]}1`,
              `${this.columnIndex[initialValue + totalConsolidado + 1 + forescast.length * totalMonthHierarchy]}1:${
                this.columnIndex[
                  initialValue +
                    totalConsolidado +
                    1 +
                    forescast.length * totalMonthHierarchy +
                    monthAnnualPlan.length -
                    1
                ]
              }1`,
              `${
                this.columnIndex[
                  initialValue + totalConsolidado + 1 + forescast.length * totalMonthHierarchy + monthAnnualPlan.length
                ]
              }1:${
                this.columnIndex[
                  initialValue +
                    totalConsolidado +
                    1 +
                    forescast.length * totalMonthHierarchy +
                    monthAnnualPlan.length +
                    monthlyAnnualPlanNormalization.length -
                    1
                ]
              }1`,
              `${
                this.columnIndex[
                  initialValue +
                    totalConsolidado +
                    1 +
                    forescast.length * totalMonthHierarchy +
                    monthAnnualPlan.length +
                    monthlyAnnualPlanNormalization.length
                ]
              }1:${
                this.columnIndex[
                  initialValue +
                    totalConsolidado +
                    1 +
                    forescast.length * totalMonthHierarchy +
                    monthAnnualPlan.length +
                    monthlyAnnualPlanNormalization.length +
                    forecastDescription.length -
                    1
                ]
              }1`,

              `A2:${this.columnIndex[initialValue - 1]}2`,
              `${this.columnIndex[initialValue + 1 - 1]}2:${this.columnIndex[initialValue + totalConsolidado - 1]}2`,
              `${this.columnIndex[initialValue + totalConsolidado]}2:${
                this.columnIndex[initialValue + totalConsolidado]
              }2`,
              ..._.map(
                _.filter(
                  sectionColumnsDescription,
                  (d: any) =>
                    d.key != 'main' &&
                    d.key != 'consolidate' &&
                    d.key != 'forecast_year_now' &&
                    d.key != 'monthlyAnnualPlanNormalization' &&
                    d.key != 'monthlyAnnualPlan' &&
                    d.key.length < 2
                ),
                (c: any) => `${this.columnIndex[c.index + 1]}2:${this.columnIndex[c.index + totalMonthHierarchy]}2`
              ),
              `${this.columnIndex[initialValue + totalConsolidado + 1 + forescast.length * totalMonthHierarchy]}2:${
                this.columnIndex[
                  initialValue +
                    totalConsolidado +
                    1 +
                    forescast.length * totalMonthHierarchy +
                    monthAnnualPlan.length -
                    1
                ]
              }2`,
              `${
                this.columnIndex[
                  initialValue + totalConsolidado + 1 + forescast.length * totalMonthHierarchy + monthAnnualPlan.length
                ]
              }2:${
                this.columnIndex[
                  initialValue +
                    totalConsolidado +
                    1 +
                    forescast.length * totalMonthHierarchy +
                    monthAnnualPlan.length +
                    monthlyAnnualPlanNormalization.length -
                    1
                ]
              }2`
            ]
          } as any)
      )
    };
    return this;
  }
}
